<template>
  <div class="achievement-library">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>成果物生成</h2>
    </div>

    <!-- 描述文本 -->
    <div class="description">
      <p>基于最终解决方案生成多种形式的Word文档</p>
      <p>选择需要生成的文档类型，系统将自动整合最终方案内容并生成专业的Word文档供下载。</p>
    </div>

    <!-- 文档类型卡片网格 -->
    <div class="document-grid">
      <!-- 最终解决方案（完整版） -->
      <div class="document-card primary-card developed-card">
        <div class="card-header">
          <div class="card-icon">
            <el-icon><Document /></el-icon>
          </div>
          <h3 class="card-title">最终解决方案（完整版）</h3>
        </div>
        <div class="card-description">结构化且可编辑的完整技术方案。</div>
        <el-button
          type="primary"
          size="small"
          class="generate-btn"
          :loading="generatingType === 1"
          :disabled="isOtherGenerating(1)"
          @click="handleGenerate(1)"
        >
          {{ generatingType === 1 ? '生成中…' : '生成' }}
          <el-icon v-if="generatingType !== 1"><ArrowRight /></el-icon>
        </el-button>
      </div>

      <!-- 技术交底书 -->
      <div class="document-card developed-card">
        <div class="card-header">
          <div class="card-icon">
            <el-icon><Document /></el-icon>
          </div>
          <h3 class="card-title">技术交底书</h3>
        </div>
        <div class="card-description">根据技术方案自动生成详细的技术交底书，用于向专利代理人或相关部门完整披露发明创新内容。</div>
        <el-button
          type="default"
          size="small"
          class="generate-btn"
          :loading="generatingType === 6"
          :disabled="isOtherGenerating(6)"
          @click="handleGenerate(6)"
        >
          {{ generatingType === 6 ? '生成中…' : '生成' }}
          <el-icon v-if="generatingType !== 6"><ArrowRight /></el-icon>
        </el-button>
      </div>

      <!-- 研发立项报告 -->
      <div class="document-card">
        <div class="card-header">
          <div class="card-icon">
            <el-icon><Document /></el-icon>
          </div>
          <h3 class="card-title">研发立项报告</h3>
        </div>
        <div class="card-description">包含技术可行性、市场需求、预算和时间节点。</div>
        <el-button
          type="default"
          size="small"
          class="generate-btn"
          :loading="generatingType === 2"
          :disabled="isOtherGenerating(2)"
          @click="handleGenerate(2)"
        >
          {{ generatingType === 2 ? '生成中…' : '生成' }}
          <el-icon v-if="generatingType !== 2"><ArrowRight /></el-icon>
        </el-button>
      </div>

      <!-- 资源需求报告 -->
      <div class="document-card">
        <div class="card-header">
          <div class="card-icon">
            <el-icon><Document /></el-icon>
          </div>
          <h3 class="card-title">资源需求报告</h3>
        </div>
        <div class="card-description">详细列出所需材料、工艺设备、测试场景及成本预估。</div>
        <el-button
          type="default"
          size="small"
          class="generate-btn"
          :loading="generatingType === 3"
          :disabled="isOtherGenerating(3)"
          @click="handleGenerate(3)"
        >
          {{ generatingType === 3 ? '生成中…' : '生成' }}
          <el-icon v-if="generatingType !== 3"><ArrowRight /></el-icon>
        </el-button>
      </div>

      <!-- 可专利分析 -->
      <div class="document-card">
        <div class="card-header">
          <div class="card-icon">
            <el-icon><Document /></el-icon>
          </div>
          <h3 class="card-title">可专利分析</h3>
        </div>
        <div class="card-description">分析最终方案中可申请专利的核心创新点和技术特征。</div>
        <el-button
          type="default"
          size="small"
          class="generate-btn"
          :loading="generatingType === 4"
          :disabled="isOtherGenerating(4)"
          @click="handleGenerate(4)"
        >
          {{ generatingType === 4 ? '生成中…' : '生成' }}
          <el-icon v-if="generatingType !== 4"><ArrowRight /></el-icon>
        </el-button>
      </div>

      <!-- 专利侵权规避/分析 -->
      <div class="document-card">
        <div class="card-header">
          <div class="card-icon">
            <el-icon><Document /></el-icon>
          </div>
          <h3 class="card-title">专利侵权规避/分析</h3>
        </div>
        <div class="card-description">对比关键专利，给出侵权规避设计建议。</div>
        <el-button
          type="default"
          size="small"
          class="generate-btn"
          :loading="generatingType === 5"
          :disabled="isOtherGenerating(5)"
          @click="handleGenerate(5)"
        >
          {{ generatingType === 5 ? '生成中…' : '生成' }}
          <el-icon v-if="generatingType !== 5"><ArrowRight /></el-icon>
        </el-button>
      </div>
    </div>
    <!-- 返回按钮 -->
    <div class="back-btn-container" style="margin-top: 20px; display: flex; justify-content: space-between; align-items: center;">
      <el-button type="info" @click="handleBack" style="background-color: #fff; color: #333;">
        <el-icon><ArrowLeft /></el-icon>
        返回上一步
      </el-button>
      <el-button type="info"  @click="handleBackToHome" style="background-color: #fff; color: #333;">
        <el-icon><House /></el-icon>
        返回首页
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Document, ArrowRight, ArrowLeft, House } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
const props = defineProps({
  solutionData: {
    type: Object,
    default: () => ({})
  },
  // 项目ID：成果物落库用
  projectId: {
    type: [String, Number],
    default: null
  }
})

// 定义组件发射的事件
const emit = defineEmits(['back', 'back-to-home'])

// 生成状态：记录当前是哪张卡片在生成（null 表示空闲）。
// 原来是一个全局布尔 + 贴在视口顶部的固定横条，既盖住顶端导航栏，也无法区分是哪一项在生成。
const generatingType = ref(null)
// 生成中时禁用其他卡片，避免同时跑多个生成任务
const isOtherGenerating = (type) => generatingType.value !== null && generatingType.value !== type

// 成果物落库（静默）：先把 docx 传 OSS 拿到对象路径，再记录到 generated_artifacts。
//
// 与旧实现的三点差别：
//  1. blob 真正上传到 OSS，ossPath 记录对象路径；旧实现只存了浏览器下载名，文件无处可寻。
//  2. contentData 存「模型改写后实际套进模板的内容」（由 X-Generated-Content 头回传），
//     旧实现存的是送进接口的方案原文，导致 4 个模板的 content_data 完全相同。
//  3. solutionId 一并落库，旧实现恒为 null，成果物与方案无法关联。
const TEMPLATE_NAMES = {
  1: '最终解决方案',
  2: '研发立项报告',
  3: '资源需求报告',
  6: '技术交底书'
}

const readGeneratedContent = (response) => {
  const raw = response.headers.get('X-Generated-Content')
  if (!raw) return null
  try {
    return JSON.parse(decodeURIComponent(raw))
  } catch (e) {
    console.warn('[artifact] 响应头内容解析失败，退回方案原文落库')
    return null
  }
}

const uploadArtifactBlob = async (docType, blob, fileName) => {
  const form = new FormData()
  form.append('file', blob, fileName)
  form.append('projectId', String(props.projectId))
  form.append('docType', String(docType))
  const { tdsFetch } = await import('@/utils/fetch')
  const { sysPrefix } = await import('@/api/persistence')
  return tdsFetch(`${sysPrefix}/generated-artifact/upload`, {
    method: 'POST',
    body: form,
    joinPrefix: false
  })
}

const persistArtifact = async (docType, { blob = null, fileName = '', fallbackData = null, generated = null } = {}) => {
  if (!props.projectId) return
  // 上传失败不能影响用户下载，全程静默
  let ossPath = null
  try {
    if (blob) ossPath = await uploadArtifactBlob(docType, blob, fileName)
  } catch (e) {
    console.error('成果物上传 OSS 失败（静默）:', e)
  }

  const content = generated || fallbackData

  try {
    const { addArtifact } = await import('@/api/persistence')
    await addArtifact({
      projectId: Number(props.projectId),
      solutionId: null,
      docType,
      templateName: TEMPLATE_NAMES[docType] || '',
      contentData: content ? JSON.stringify(content) : null,
      fileUrl: fileName || null,
      ossPath: ossPath || null
    })
    console.log(`成果物已落库: docType=${docType} ossPath=${ossPath || '(上传失败)'}`)
  } catch (e) {
    console.error('成果物落库失败（静默）:', e)
  }
}

console.log(props.solutionData)

// 章节内容可能是富文本编辑器产出的 HTML（用户在方案页编辑保存过），
// 而 Word 生成链路（docxtemplater，linebreaks:true）不做 HTML 清洗，
// 会把 <p> 当成正文原样打进文档。这里是所有成果物生成的统一入口，先统一转纯文本。
const htmlToPlainText = (value) => {
  if (value === null || value === undefined) return ''
  const text = String(value)
  // 没有 HTML 标签就原样返回（纯文本不碰，实体也不解，避免误伤正常文本）
  if (!/<[a-zA-Z][^>]*>/.test(text)) return text
  return text
    .replace(/<\s*(br|\/p|\/div|\/li|\/h[1-6]|\/tr|\/td)\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

// 将 solutionData 转换为指定 JSON 格式的函数
const convertSolutionDataToJson = (solutionData) => {
  // 检查 solutionData 是否为数组
  if (!Array.isArray(solutionData)) {
    console.error('solutionData 不是数组格式');
    return {};
  }
  
  // 遍历数组，构建新的 JSON 对象（内容统一转纯文本）
  const result = {};
  solutionData.forEach(item => {
    if (item.key && item.content !== undefined) {
      result[item.key] = htmlToPlainText(item.content);
    }
  });
  
  return result;
}
// 生成带日期的文件名
const generateFileName = () => {
  // 硬编码为新颖性检索加上日期时间，格式为: 新颖性检索2025-07-13 16∶07∶27.docx
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')

  return `最终解决方案${year}-${month}-${day} ${hours}∶${minutes}∶${seconds}.docx`
}


// 可以添加生成按钮点击事件处理函数
const handleGenerate = (type) => {
  if(type === 1) {
    // 生成最终解决方案
    const dataToUse = convertSolutionDataToJson(props.solutionData);
    console.log(`生成${type}文档使用的数据:`, dataToUse);
    convertDataToDocx(dataToUse)
  } else if(type === 6) {
    // 生成技术交底书
    const dataToUse = convertSolutionDataToJson(props.solutionData);
    console.log(`生成技术交底书使用的数据:`, dataToUse);
    generateTechnicalDisclosure(dataToUse)
  } else if(type === 2) {
    // 生成研发立项报告
    const dataToUse = convertSolutionDataToJson(props.solutionData);
    console.log(`生成研发立项报告使用的数据:`, dataToUse);
    generateProjectProposal(dataToUse)
  } else if(type === 3) {
    // 生成资源需求报告
    const dataToUse = convertSolutionDataToJson(props.solutionData);
    console.log(`生成资源需求报告使用的数据:`, dataToUse);
    generateResourceReport(dataToUse)
  } else {
    ElMessage.warning('功能开发中');
    return
  }
}
// 将数据转换为docx文件的函数
const convertDataToDocx = async (data) => {
  try {
    // 这条路径原来完全没有加载状态，点「生成」时界面毫无反馈
    generatingType.value = 1;
    const response = await fetch('/api/problemReport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    
    if (!response.ok) throw new Error('文档生成失败');
    // 先取响应头里的真实内容，再消费 body
    const generated = readGeneratedContent(response);
    // 处理返回的文档流
    const fileName = generateFileName();
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    let file;
    try {
      // 创建File对象
      file = new File([blob], fileName, { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // 清理URL对象
      window.URL.revokeObjectURL(url);
      ElMessage.success('最终解决方案成功生成');
      // 成果物落库（静默）
      persistArtifact(1, { blob, fileName, fallbackData: data, generated });

    } catch (uploadError) {
      ElMessage.error('最终解决方案生成失败');
    }

  } catch (error) {

    console.error('转换为Word文档失败:', error);
    ElMessage.error('转换为Word文档失败: ' + error.message);
  } finally {
    generatingType.value = null;
  }
}

// 生成技术交底书的函数
const generateTechnicalDisclosure = async (data) => {
  console.log(data);
  try {
    // 设置加载状态：对应按钮转圈，其余卡片禁用
    generatingType.value = 6;
    
    const response = await fetch('/api/technicalDisclosure', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    
    if (!response.ok) throw new Error('技术交底书生成失败');
    // 先取响应头里的真实内容，再消费 body
    const generated = readGeneratedContent(response);
    // 处理返回的文档流
    const fileName = `技术交底书${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.docx`;
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    try {
      // 创建File对象
      const file = new File([blob], fileName, { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // 清理URL对象
      window.URL.revokeObjectURL(url);
      ElMessage.success('技术交底书成功生成');
      // 成果物落库（静默）
      persistArtifact(6, { blob, fileName, fallbackData: data, generated });

    } catch (uploadError) {
      ElMessage.error('技术交底书生成失败');
    }

  } catch (error) {

    console.error('生成技术交底书失败:', error);
    ElMessage.error('生成技术交底书失败: ' + error.message);
  } finally {
    // 重置加载状态
    generatingType.value = null;
  }
}

// 通用：调用报告生成接口 → 下载 docx → 落库
const generateReportDocx = async (endpoint, label, docType, data) => {
  try {
    generatingType.value = docType;

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      let msg = `${label}生成失败`;
      try {
        const err = await response.json();
        if (err && err.error) msg = err.error;
      } catch (e) { /* 响应非JSON，忽略 */ }
      throw new Error(msg);
    }

    const fileName = `${label}${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.docx`;
    // 先取响应头里的真实内容，再消费 body
    const generated = readGeneratedContent(response);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    ElMessage.success(`${label}成功生成`);
    persistArtifact(docType, { blob, fileName, fallbackData: data, generated });
  } catch (error) {
    console.error(`${label}生成失败:`, error);
    ElMessage.error(`${label}生成失败：` + (error.message || '请重试'));
  } finally {
    generatingType.value = null;
  }
}

// 生成研发立项报告
const generateProjectProposal = (data) => generateReportDocx('/api/projectProposal', '研发立项报告', 2, data)

// 生成资源需求报告
const generateResourceReport = (data) => generateReportDocx('/api/resourceReport', '资源需求报告', 3, data)

// 处理返回上一步点击事件
const handleBack = () => {
  // 触发返回上一步事件
  emit('back');
}

// 处理返回首页点击事件
const handleBackToHome = () => {
  // 触发返回首页事件
  emit('back-to-home');
}
</script>

<style scoped lang="scss">
.achievement-library {
  display: flex;
  flex-direction: column;
  padding: 30px;
  background-color: #f5f7fa;
}

/* 页面标题 */
.page-header {
  margin-bottom: 20px;
  
  h2 {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }
}

/* 描述文本 */
.description {
  margin-bottom: 30px;
  
  p {
    font-size: 14px;
    color: #666;
    margin: 8px 0;
    line-height: 1.5;
  }
}

/* 文档类型卡片网格 */
.document-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 1000px;
}

/* 文档卡片 */
.document-card {
  background-color: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }
}

/* 主要卡片样式 */
.primary-card {
  background-color: #f0f9ff;
  border-color: #90caf9;
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

/* 卡片图标 */
.card-icon {
  width: 40px;
  height: 40px;
  background-color: #e6f5ee;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  :deep(.el-icon) {
    font-size: 20px;
    color: #42e25f;
  }
}

/* 卡片标题 */
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

/* 卡片描述 */
.card-description {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  flex: 1;
}

/* 生成按钮 */
.generate-btn {
  align-self: flex-start;
  padding: 20px 48px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 20px;
  background-color: #ffffff;
  border: 1px solid #000000;
  color: #000000;
  transition: all 0.3s ease;
  
  :deep(.el-icon) {
    margin-left: 4px;
    font-size: 16px;
  }
  
  &:hover {
    background-color: #000000;
    color: #ffffff;
    border-color: #000000;
  }
}

/* 已开发功能卡片样式 */
.developed-card {
  border: 1px solid #000000;
  
  .card-icon {
    background-color: #f0f0f0;
    
    :deep(.el-icon) {
      color: #000000;
    }
  }
  
  .card-title {
    color: #000000;
  }
  
  .generate-btn {
    background-color: #000000;
    border-color: #000000;
    color: #ffffff;
    
    &:hover {
      background-color: #ffffff;
      color: #000000;
      border-color: #000000;
    }
  }
}

/* 主要卡片的生成按钮 */
.primary-card .generate-btn {
  background-color: #000000;
  border-color: #000000;
  color: #ffffff;
  
  &:hover {
    background-color: #ffffff;
    color: #000000;
    border-color: #000000;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .document-grid {
    grid-template-columns: 1fr;
  }
}

/* 顶部固定横条已移除：加载反馈改为对应按钮内的旋转动效（generatingType） */
</style>